module.exports = __webpack_public_path__ + "static/media/logo-plus.e1a54cd9.svg";